window.addEventListener('load', () => {
  setTimeout(() => {
    document.body.classList.add('is-ready');
  }, 1000);
});
